import {
  HYBRYD_QUICK_SEARCH_MERCHANTS_GET_SUCCESS,
  HYBRYD_QUICK_SEARCH_MERCHANTS_GET_FAILURE,
} from '../actions/types';

const initialState = {
  isLoading: false,
  isLoaded: false,
  merchants: [],
};

const quickSearchMerchants = (state = initialState, action) => {
  switch (action.type) {
    case HYBRYD_QUICK_SEARCH_MERCHANTS_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        merchants: action.payload.response,
      };
    }
    case HYBRYD_QUICK_SEARCH_MERCHANTS_GET_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        merchants: [],
      };
    }

    default: {
      const { options = {} } = action;
      if (options.success === HYBRYD_QUICK_SEARCH_MERCHANTS_GET_SUCCESS) {
        return {
          ...state,
          isLoading: true,
          isLoaded: false,
        };
      }
    }
  }

  return state;
};

export default quickSearchMerchants;
